import {noop} from 'lodash'

import {GlobalActionsInterface} from 'constants/globalActions'

export const actionsMap: GlobalActionsInterface = {
  example: () => noop,
}
